module.exports = __webpack_public_path__ + "static/media/colored-heels.9229f29f.jpg";